import React, { useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ColumnGroupingTable from "../../../table/ColumnGroupingTable.component";
import { Typography } from "@mui/material";
import { useHedgeRatioContext } from "../../../../context/HedgeRatioContext"; // 💡 Added import
import { applyFigureFormatting } from "../../../../utils/utils"; // 💡 Added import
import { stLiabilitiesOnBs } from "../responseApi";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const STLiabilitiesOnBsTable = ({ setSTLiabilitiesOnBsTableDatas } = {}) => {
  const { selectedFigureDivisor, selectedDecimalsIn } = useHedgeRatioContext();
  const columns = [
    {
      label: "S/T Liabilities on BS",
      children: [
        {
          id: "liabilitiesName",
          label: "Name",
          minWidth: 140,
        },
        {
          id: "liabilitiesValue",
          label: "Value",
          minWidth: 140,
          align: "right",
        },
      ],
    },
  ];

  const totalLiabilitiesValue = useMemo(() => {
    return stLiabilitiesOnBs.reduce(
      (sum, stReceivable) => sum + stReceivable.liabilitiesValue,
      0
    );
  }, []);

  const stLiabilitiesOnBsDataRows = useMemo(() => {
    return stLiabilitiesOnBs?.map(({ liabilitiesName, liabilitiesValue }) => ({
      liabilitiesName,
      liabilitiesValue: applyFigureFormatting(
        liabilitiesValue,
        selectedFigureDivisor,
        selectedDecimalsIn
      ),
      minWidth: 120,
      align: "left",
    }));
  }, [selectedFigureDivisor, selectedDecimalsIn]);
  const totalSTLiabilitiesRow = useMemo(() => {
    return {
      liabilitiesName: "S/T Debt",
      liabilitiesValue: applyFigureFormatting(
        totalLiabilitiesValue,
        selectedFigureDivisor,
        selectedDecimalsIn
      ),
      minWidth: 120,
      align: "left",
      cellStyles: {
        fontWeight: "bold",
        backgroundColor: "#F5F5F5",
        borderTop: "1px solid #000000",
        borderBottom: "1px solid #000000",
      },
    };
  }, [totalLiabilitiesValue, selectedFigureDivisor, selectedDecimalsIn]);

  const datas = useMemo(() => {
    return stLiabilitiesOnBsDataRows
      ? [...stLiabilitiesOnBsDataRows, totalSTLiabilitiesRow]
      : [totalSTLiabilitiesRow];
  }, [stLiabilitiesOnBsDataRows, totalSTLiabilitiesRow]);

  useEffect(() => {
    setSTLiabilitiesOnBsTableDatas(datas);
  }, [datas, setSTLiabilitiesOnBsTableDatas]);

  return (
    <Grid container spacing={2} sx={{ marginBottom: 0 }}>
      <Grid item xs={12} md={12} lg={12}>
        {!stLiabilitiesOnBs ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              There was an error in fetching the data. Please try again later.
            </Typography>
          </Item>
        ) : !stLiabilitiesOnBs?.length ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              No data available for the selected filters.
            </Typography>
          </Item>
        ) : (
          // ST Liabilities on BS
          <ColumnGroupingTable
            columns={columns}
            datas={datas}
            loading={false}
            disablePagination={true}
            applyThousandsSeparator={true}
            tableHeight={280}
            hideChildRowHeader
          />
        )}
      </Grid>
    </Grid>
  );
};

export default STLiabilitiesOnBsTable;
